import React from 'react';
import { useLocation } from 'react-router-dom';
import { usePwaInstallContext } from '../context/PwaInstallContext';
import { isAndroidDevice } from '../pwa/pwaInstallUtils';
import './pwa-install.css';

function InstallAppIcon() {
  return (
    <svg
      className="pwa-install-drawer-btn__icon"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <rect x="5" y="2" width="14" height="20" rx="3" />
      <path d="M12 18h.01" />
    </svg>
  );
}

/** Mobile drawer install — native prompt on Android when available; guided steps otherwise. */
export default function PwaInstallNavItem({ onAfterClick }) {
  const { pathname } = useLocation();
  const { canShowInstallOffer, runInstallAction } = usePwaInstallContext();
  const isAndroid = isAndroidDevice();
  const label = isAndroid ? 'Install app' : 'Add to Home Screen';
  const hint = isAndroid ? 'Faster access from your phone' : 'Save the shop to your home screen';

  if (pathname.startsWith('/admin') || !canShowInstallOffer) return null;

  return (
    <div className="pwa-install-drawer-action">
      <button
        type="button"
        className="pwa-install-drawer-btn"
        onClick={(event) => {
          onAfterClick?.(event);
          runInstallAction();
        }}
      >
        <span className="pwa-install-drawer-btn__icon-wrap" aria-hidden>
          <InstallAppIcon />
        </span>
        <span className="pwa-install-drawer-btn__copy">
          <span className="pwa-install-drawer-btn__title">{label}</span>
          <span className="pwa-install-drawer-btn__hint">{hint}</span>
        </span>
      </button>
    </div>
  );
}
